export const translations = {
  en: {
    // Header
    siteTitle: 'Hospitality and Commercial Cleaning Services',
    tagline: 'Join Our Team',
    languageLabel: 'Language',
    
    // Careers Page
    careersTitle: 'Career Opportunities',
    careersSubtitle: 'Build your career with us in the hospitality industry',
    searchPlaceholder: 'Search positions...',
    filterPosition: 'Position Type',
    filterLocation: 'Location',
    allPositions: 'All Positions',
    allLocations: 'All Locations',
    applyNow: 'Apply Now',
    noJobs: 'No positions available at this time',
    
    // Craigslist Landing Page
    clHeroTitle: 'Join Our Hospitality Team',
    clHeroSubtitle: 'We\'re hiring dedicated professionals to join our growing team',
    clApplyNow: 'Apply Now',
    clWhyJoin: 'Flexible Job Opportunities',
    clBenefit1: 'Choose your own schedule - full-time, part-time, or weekends only',
    clBenefit2: 'Multiple positions available across different locations',
    clBenefit3: 'Immediate start dates available for qualified candidates',
    clBenefit4: 'Work in hospitality and commercial cleaning environments',
    clReadyToStart: 'Ready to Start?',
    clCtaDescription: 'Complete our quick application and join our team today',
    
    // Application Form
    applicationTitle: 'Job Application',
    step1: 'Personal Info',
    step2: 'Employment History',
    step3: 'Authorization',
    step4: 'Experience',
    step5: 'Availability',
    step6: 'Preferences',
    step7: 'Additional',
    
    // Step 1 - Personal Information
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'your.email@example.com',
    phone: 'Phone Number',
    phonePlaceholder: '(555) 123-4567',
    city: 'City/Area',
    cityPlaceholder: 'Enter your city',
    languagesSpoken: 'Languages Spoken',
    languagesSpokenHint: 'Select all that apply',
    languageEnglish: 'English',
    languageSpanish: 'Spanish',
    languageOther: 'Other',
    otherLanguagePlaceholder: 'Please specify',
    
    // Step 2 - Employment History
    mostRecentJob: 'Most Recent Job',
    mostRecentJobPlaceholder: 'Company name and position',
    whyStoppedWorking: 'Why did you stop working at your last job?',
    whyStoppedPlaceholder: 'Brief explanation...',
    currentlyWorking: 'Are you currently working?',
    currentWorkType: 'Is this full-time or part-time?',
    currentFullTime: 'Full-time',
    currentPartTime: 'Part-time',
    currentWorkDays: 'What days do you currently work?',
    currentWorkDaysPlaceholder: 'e.g., Monday-Friday',
    lookingFor: 'What type of work are you looking for?',
    lookingForPartTime: 'Part-time (in addition to current job)',
    lookingForFullTime: 'Full-time (in addition to current job)',
    lookingForSwitch: 'Switch to new full-time position',
    positionApplying: 'Position Applying For',
    positionPlaceholder: 'Select a position',
    howDidYouHear: 'How did you hear about us?',
    sourceOnline: 'Online Job Board',
    sourceReferral: 'Referral',
    sourceSocial: 'Social Media',
    sourceOther: 'Other',
    
    // Step 3 - Work Authorization & Background
    workAuthorization: 'Are you authorized to work in the United States?',
    usCitizen: 'U.S. Citizen',
    permanentResident: 'Permanent Resident',
    workPermit: 'Work Permit',
    cleanBackground: 'Do you have a clean background?',
    cleanBackgroundHint: 'No felonies or misdemeanors that would affect employment',
    
    // Step 4 - Experience & Skills
    experienceDescription: 'Please describe your housekeeping/cleaning experience',
    experienceDescriptionPlaceholder: 'Tell us about your relevant experience, skills, and what you specialized in...',
    
    // Step 5 - Availability & Start Date
    availableDays: 'Available Days',
    allDays: 'All Days',
    selectSpecificDays: 'Select Specific Days',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    availableHours: 'Available Hours',
    fullTime: 'Full-time',
    partTime: 'Part-time',
    customHours: 'Custom Hours',
    customHoursPlaceholder: 'e.g., 8am - 5pm',
    whenCanStart: 'When can you start?',
    startImmediately: 'Immediately',
    startTwoWeeks: 'Two weeks notice',
    startCustom: 'Specific date',
    startDatePlaceholder: 'MM/DD/YYYY',
    
    // Step 6 - Transportation & Preferences
    hasTransportation: 'Do you have reliable transportation?',
    canWorkWeekends: 'Can you work weekends?',
    availableFullTime: 'Are you available for full-time work?',
    hasPriorExperience: 'Do you have prior cleaning/hospitality experience?',
    yes: 'Yes',
    no: 'No',
    
    // Step 5 - Additional Information
    additionalInfo: 'Additional Information',
    additionalInfoPlaceholder: 'Tell us anything else you\'d like us to know about you...',
    resumeUpload: 'Upload Resume (Optional)',
    resumeUploadHint: 'PDF, DOC, or DOCX (Max 5MB)',
    chooseFile: 'Choose File',
    noFileChosen: 'No file chosen',
    
    // Buttons
    next: 'Next',
    back: 'Back',
    submit: 'Submit Application',
    submitting: 'Submitting...',
    
    // Messages
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    submitSuccess: 'Application submitted successfully!',
    submitError: 'Failed to submit application. Please try again.',
    thankYou: 'Thank you for applying!',
    willContact: 'We will review your application and contact you soon.',
    backToCareers: 'Back to Careers'
  },
  es: {
    // Header
    siteTitle: 'Servicios de Limpieza Hospitalaria y Comercial',
    tagline: 'Únete a Nuestro Equipo',
    languageLabel: 'Idioma',
    
    // Careers Page
    careersTitle: 'Oportunidades de Carrera',
    careersSubtitle: 'Construye tu carrera con nosotros en la industria hotelera',
    searchPlaceholder: 'Buscar posiciones...',
    filterPosition: 'Tipo de Posición',
    filterLocation: 'Ubicación',
    allPositions: 'Todas las Posiciones',
    allLocations: 'Todas las Ubicaciones',
    applyNow: 'Solicitar Ahora',
    noJobs: 'No hay posiciones disponibles en este momento',
    
    // Craigslist Landing Page
    clHeroTitle: 'Únete a Nuestro Equipo de Hospitalidad',
    clHeroSubtitle: 'Estamos contratando profesionales dedicados para unirse a nuestro equipo en crecimiento',
    clApplyNow: 'Solicitar Ahora',
    clWhyJoin: 'Oportunidades de Trabajo Flexibles',
    clBenefit1: 'Elija su propio horario - tiempo completo, medio tiempo, o solo fines de semana',
    clBenefit2: 'Múltiples posiciones disponibles en diferentes ubicaciones',
    clBenefit3: 'Fechas de inicio inmediatas disponibles para candidatos calificados',
    clBenefit4: 'Trabaje en entornos de limpieza hospitalaria y comercial',
    clReadyToStart: '¿Listo para Comenzar?',
    clCtaDescription: 'Complete nuestra solicitud rápida y únase a nuestro equipo hoy',
    
    // Application Form
    applicationTitle: 'Solicitud de Empleo',
    step1: 'Información Personal',
    step2: 'Historial Laboral',
    step3: 'Autorización',
    step4: 'Experiencia',
    step5: 'Disponibilidad',
    step6: 'Preferencias',
    step7: 'Adicional',
    
    // Step 1 - Personal Information
    fullName: 'Nombre Completo',
    fullNamePlaceholder: 'Ingrese su nombre completo',
    email: 'Correo Electrónico',
    emailPlaceholder: 'su.correo@ejemplo.com',
    phone: 'Número de Teléfono',
    phonePlaceholder: '(555) 123-4567',
    city: 'Ciudad/Área',
    cityPlaceholder: 'Ingrese su ciudad',
    languagesSpoken: 'Idiomas que Habla',
    languagesSpokenHint: 'Seleccione todos los que correspondan',
    languageEnglish: 'Inglés',
    languageSpanish: 'Español',
    languageOther: 'Otro',
    otherLanguagePlaceholder: 'Por favor especifique',
    
    // Step 2 - Employment History
    mostRecentJob: 'Trabajo Más Reciente',
    mostRecentJobPlaceholder: 'Nombre de la empresa y posición',
    whyStoppedWorking: '¿Por qué dejó de trabajar en su último empleo?',
    whyStoppedPlaceholder: 'Breve explicación...',
    currentlyWorking: '¿Está trabajando actualmente?',
    currentWorkType: '¿Es tiempo completo o medio tiempo?',
    currentFullTime: 'Tiempo completo',
    currentPartTime: 'Medio tiempo',
    currentWorkDays: '¿Qué días trabaja actualmente?',
    currentWorkDaysPlaceholder: 'ej., Lunes-Viernes',
    lookingFor: '¿Qué tipo de trabajo está buscando?',
    lookingForPartTime: 'Medio tiempo (además del trabajo actual)',
    lookingForFullTime: 'Tiempo completo (además del trabajo actual)',
    lookingForSwitch: 'Cambiar a nueva posición de tiempo completo',
    positionApplying: 'Posición a la que Aplica',
    positionPlaceholder: 'Seleccione una posición',
    howDidYouHear: '¿Cómo se enteró de nosotros?',
    sourceOnline: 'Bolsa de Trabajo en Línea',
    sourceReferral: 'Referencia',
    sourceSocial: 'Redes Sociales',
    sourceOther: 'Otro',
    
    // Step 3 - Work Authorization & Background
    workAuthorization: '¿Está autorizado para trabajar en los Estados Unidos?',
    usCitizen: 'Ciudadano estadounidense',
    permanentResident: 'Residente permanente',
    workPermit: 'Permiso de trabajo',
    cleanBackground: '¿Tiene antecedentes limpios?',
    cleanBackgroundHint: 'Sin delitos graves o menores que afecten el empleo',
    
    // Step 4 - Experience & Skills
    experienceDescription: 'Por favor describa su experiencia en limpieza/hospitalidad',
    experienceDescriptionPlaceholder: 'Cuéntenos sobre su experiencia relevante, habilidades y en qué se especializó...',
    
    // Step 5 - Availability & Start Date
    availableDays: 'Días Disponibles',
    allDays: 'Todos los Días',
    selectSpecificDays: 'Seleccionar Días Específicos',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    availableHours: 'Horas Disponibles',
    fullTime: 'Tiempo completo',
    partTime: 'Medio tiempo',
    customHours: 'Horas Personalizadas',
    customHoursPlaceholder: 'ej., 8am - 5pm',
    whenCanStart: '¿Cuándo puede comenzar?',
    startImmediately: 'Inmediatamente',
    startTwoWeeks: 'Dos semanas de aviso',
    startCustom: 'Fecha específica',
    startDatePlaceholder: 'MM/DD/AAAA',
    
    // Step 6 - Transportation & Preferences
    hasTransportation: '¿Tiene transporte confiable?',
    canWorkWeekends: '¿Puede trabajar los fines de semana?',
    availableFullTime: '¿Está disponible para trabajo de tiempo completo?',
    hasPriorExperience: '¿Tiene experiencia previa en limpieza/hospitalidad?',
    yes: 'Sí',
    no: 'No',
    
    // Step 5 - Additional Information
    additionalInfo: 'Información Adicional',
    additionalInfoPlaceholder: 'Cuéntenos cualquier otra cosa que le gustaría que supiéramos sobre usted...',
    resumeUpload: 'Subir Currículum (Opcional)',
    resumeUploadHint: 'PDF, DOC, o DOCX (Máx 5MB)',
    chooseFile: 'Elegir Archivo',
    noFileChosen: 'Ningún archivo seleccionado',
    
    // Buttons
    next: 'Siguiente',
    back: 'Atrás',
    submit: 'Enviar Solicitud',
    submitting: 'Enviando...',
    
    // Messages
    required: 'Este campo es obligatorio',
    invalidEmail: 'Por favor ingrese un correo electrónico válido',
    invalidPhone: 'Por favor ingrese un número de teléfono válido',
    submitSuccess: '¡Solicitud enviada exitosamente!',
    submitError: 'Error al enviar la solicitud. Por favor intente de nuevo.',
    thankYou: '¡Gracias por aplicar!',
    willContact: 'Revisaremos su solicitud y nos comunicaremos pronto.',
    backToCareers: 'Volver a Carreras'
  }
};